import type { RegistrationNumberAlertFormState } from "../../../services/update-form/registrationNumberAlert";
import type { BookingFormStateKeys } from "../../../services/update-form/updateFormReducer";
import { getKeysToChangeForArrivalNotepad } from "../../registrationNumberAlert/utils/arrivalNotepadUtil";

export const getValuesForUpdateForm = (
  registrationNumberAlert: RegistrationNumberAlertFormState,
): BookingFormStateKeys => {
  return getKeysToChangeForArrivalNotepad(registrationNumberAlert);
};
